import ArrowBack from '@material-ui/icons/ArrowBack';
import SettingsOutlined from '@material-ui/icons/SettingsOutlined';
import { Loading } from '@monorepo/shared/components/Loading';
import { Button } from '@monorepo/shared/componentsV2/Button';
import { IconButton } from '@monorepo/shared/componentsV2/Button/IconButton';
import { ButtonsGroup } from '@monorepo/shared/componentsV2/ButtonsGroup';
import { Header } from '@monorepo/shared/componentsV2/Header';
import { MenuButton } from '@monorepo/shared/componentsV2/menus/MenuButton';
import { Search } from '@monorepo/shared/componentsV2/Search';
import { useTableBulkActions } from '@monorepo/shared/componentsV2/Table/useTableBulkActions';
import { VisuallyHidden } from '@monorepo/shared/componentsV2/VisuallyHidden';
import { useHasOrgUpdatePermissionOrSuperAdmin } from '@monorepo/shared/hooks/permissions/useHasPermissions';
import { useResourceType } from '@monorepo/shared/hooks/resources/useResourceType';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';

const StyledSearch = styled(Search)`
  width: 16rem;
`;

const ButtonContainer = styled.div`
  min-width: 7rem;

  & > button {
    width: 100%;
  }
`;

type ViewResourcesHeaderProps = {
  onSearchChange?: React.ComponentProps<typeof Search>['onChange'];
  onSettingsClick: React.ComponentProps<typeof Button>['onClick'];
  onAddNew: React.MouseEventHandler;
  onAddNewFromFile: () => void;
};

export function ViewResourcesHeader(props: ViewResourcesHeaderProps) {
  const { onSearchChange, onSettingsClick, onAddNew, onAddNewFromFile } = props;

  const { organizationId, resourceTypeId } = useParams();
  const canEditOrgSettings =
    useHasOrgUpdatePermissionOrSuperAdmin(organizationId);
  const { isBulkActionsModeOn } = useTableBulkActions();

  const { resourceType, isLoading } = useResourceType({
    organizationId,
    resourceTypeId,
  });
  const resourceTypeName = resourceType?.name || '';

  const navigate = useNavigate();

  return isLoading ? (
    <Loading />
  ) : (
    <Header
      variant="noDropShadow"
      title={resourceTypeName}
      leftActions={
        // TODO: convert to an absolute link instead of a relative link
        <IconButton onClick={() => navigate('../../../..')}>
          <ArrowBack />
          <VisuallyHidden>Back</VisuallyHidden>
        </IconButton>
      }
      rightActions={
        <ButtonsGroup>
          {onSearchChange && (
            <StyledSearch
              placeholder="Search any text or date field"
              onChange={onSearchChange}
            />
          )}
          <ButtonContainer>
            <Button
              variant="outlined"
              color="primary"
              onClick={onSettingsClick}
            >
              <SettingsOutlined />
              Settings
            </Button>
          </ButtonContainer>
          {canEditOrgSettings && !isBulkActionsModeOn && (
            <ButtonContainer>
              <MenuButton
                label="Add Resources"
                options={[
                  { onClick: onAddNew, displayName: 'Add manually' },
                  { onClick: onAddNewFromFile, displayName: 'Upload file' },
                ]}
                menuWidthShouldMatchButtonEl
              />
            </ButtonContainer>
          )}
        </ButtonsGroup>
      }
    />
  );
}
